import { NavLink, Link } from "react-router-dom";
import { Flame, Menu, X } from "lucide-react";
import { useState } from "react";

const links = [
  { to: "/", label: "Memorial", testid: "nav-home" },
  { to: "/timeline", label: "Timeline", testid: "nav-timeline" },
  { to: "/path", label: "Path of Survival", testid: "nav-path" },
  { to: "/stories", label: "Survivors", testid: "nav-stories" },
  { to: "/share", label: "Share Your Story", testid: "nav-share" },
  { to: "/memorial", label: "Remembrance", testid: "nav-memorial" },
  { to: "/learn", label: "Learn", testid: "nav-learn" },
  { to: "/act", label: "Take Action", testid: "nav-act" },
];

export const Nav = () => {
  const [open, setOpen] = useState(false);
  return (
    <header
      className="sticky top-0 z-40 backdrop-blur-md bg-[#0A0A0C]/80 border-b border-white/10"
      data-testid="site-nav"
    >
      <div className="max-w-6xl mx-auto px-6 lg:px-12 py-5 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 group" data-testid="nav-brand">
          <Flame
            className="w-5 h-5 text-[#D4AF37] flame"
            strokeWidth={1.25}
          />
          <div className="leading-tight">
            <div className="font-serif-display text-lg tracking-tight text-[#F2EBE5]">
              Sinjar Remembered
            </div>
            <div className="overline mt-0.5">August 3, 2014</div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-1">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={l.testid}
              end={l.to === "/"}
              className={({ isActive }) =>
                `px-3 py-2 text-sm tracking-wide transition-colors duration-500 border-b border-transparent ${
                  isActive
                    ? "text-[#D4AF37] border-[#D4AF37]"
                    : "text-[#A19D98] hover:text-[#F2EBE5]"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <button
          className="lg:hidden text-[#F2EBE5]"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
          data-testid="nav-menu-toggle"
        >
          {open ? <X strokeWidth={1.25} /> : <Menu strokeWidth={1.25} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-white/10 bg-[#0A0A0C]" data-testid="mobile-menu">
          <div className="max-w-6xl mx-auto px-6 py-4 flex flex-col">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                onClick={() => setOpen(false)}
                data-testid={`mobile-${l.testid}`}
                className={({ isActive }) =>
                  `py-3 text-sm border-b border-white/5 ${
                    isActive ? "text-[#D4AF37]" : "text-[#A19D98]"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </header>
  );
};

export default Nav;
